import React from 'react';
import { Link } from 'react-router-dom';
import './Logo.css';

const Logo = () => {
  // Using local image from public/images folder
  const cartImageUrl = '/images/SLN_logo.png';
  
  return (
    <Link to="/" className="logo-container">
      <div className="logo-image-wrapper">
        <img 
          src={cartImageUrl} 
          alt="SLN Book World - Shopping Cart with Books" 
          className="logo-image"
          onError={(e) => {
            // Fallback to root folder if image doesn't exist
            if (cartImageUrl.includes('/images/')) {
              e.target.src = '/SLN_logo.png';
            } else {
              e.target.src = '/images/SLN_logo.png';
            }
          }}
        />
      </div>
      <div className="logo-text">
        <span className="logo-main">
          <span className="logo-s">S</span><span className="logo-l">L</span><span className="logo-n-wrapper">
            <span className="logo-n">N</span>
          </span> <span className="logo-book">Book</span> <span className="logo-world">World</span>
        </span>
        <span className="logo-tagline">
          ALL YOUR CHILD'S SCHOOL BOOKS, IN ONE CLICK!
        </span>
      </div>
    </Link>
  );
};

export default Logo;
